import { useEffect, useState } from 'react';
import '../css/OpenInApp.css';

const appStoreUrl = 'https://apps.apple.com/us/app/field-facts-baseball/id1352780085';

const isMobile = () =>
  /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

// Keeps the iOS Smart App Banner pointing at this exact field (Safari reads
// the meta on page load, which is how shared links arrive), and offers an
// explicit "Open in the app" pill for everyone else. The button tries the
// app's custom URL scheme; if the app isn't installed nothing happens and
// the App Store link is right next to it.
export const OpenInApp = ({ fieldId }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const banner = document.querySelector('meta[name="apple-itunes-app"]');
    if (banner && fieldId) {
      banner.setAttribute(
        'content',
        `app-id=1352780085, app-argument=https://fieldfactsbaseball.com/fields/${fieldId}`,
      );
    }

    setIsVisible(isMobile());
  }, [fieldId]);

  if (!isVisible || !fieldId) {
    return null;
  }

  return (
    <div className="ff-open-in-app">
      <a
        className="ff-button ff-button-gold"
        href={`fieldfactsbaseball://fields/${fieldId}`}
      >
        Open in the app
      </a>
      <a className="ff-open-in-app-store-link" href={appStoreUrl}>
        Don&apos;t have it? Get Field Facts free
      </a>
    </div>
  );
};
